export default __webpack_public_path__ + "static/media/DSC05800.d9ee7114.jpg";